import { createReducer } from '@reduxjs/toolkit'
import { User } from 'interfaces/api/users.interfaces'
import { uniqBy } from 'lodash'
import { ValidationErrorsApi } from 'packages/api'
import { createBuilder } from 'packages/redux-toolkit'

import {
  createUser,
  getAllUsers,
  getUser,
  resetUserPassword,
  setSingleUser,
  setUserValidationErrors,
  updateUser,
} from './actions'

interface UsersState {
  list: {
    loading: boolean
    items: User[]
    count: number
  }
  single: {
    loading: boolean
    item: User | null
    resetingPassword: boolean
    resetPasswordSuccess: boolean
  }
  validation: ValidationErrorsApi | null
}

const initialState: UsersState = {
  list: {
    loading: false,
    items: [],
    count: 0,
  },
  single: {
    loading: false,
    item: null,
    resetingPassword: false,
    resetPasswordSuccess: false,
  },
  validation: null,
}

export const usersReducer = createReducer(initialState, (builder) => {
  createBuilder(builder)
    .addCase(getAllUsers.pending, (state) => {
      state.list.loading = true
    })
    .addCase(getAllUsers.rejected, (state) => {
      state.list.loading = false
    })
    .addCase(getAllUsers.fulfilled, (state, { payload, meta }) => {
      state.list.loading = false
      if (meta.arg?.search) {
        state.list.items = uniqBy([...state.list.items, ...payload.results], 'id')
      } else {
        state.list.count = payload.count
        state.list.items = payload.results
      }
    })

    .addCase(getUser.pending, (state) => {
      state.single.loading = true
    })
    .addCase(getUser.rejected, (state) => {
      state.single.loading = false
      state.single.item = null
    })
    .addCase([getUser.fulfilled, setSingleUser], (state, { payload }) => {
      state.single.loading = false
      state.single.item = payload
      state.single.resetingPassword = false
      state.single.resetPasswordSuccess = false
    })

    .addCase(setUserValidationErrors, (state, { payload }) => {
      state.validation = payload
    })

    .addCase([createUser.pending, updateUser.pending], (state) => {
      state.single.loading = true
    })
    .addCase([createUser.rejected, updateUser.rejected], (state) => {
      state.single.loading = false
    })
    .addCase([createUser.fulfilled, updateUser.fulfilled], (state) => {
      state.single.loading = false
    })

    .addCase(resetUserPassword.fulfilled, (state) => {
      state.single.resetingPassword = false
      state.single.resetPasswordSuccess = true
    })
    .addCase(resetUserPassword.rejected, (state) => {
      state.single.resetingPassword = false
    })
    .addCase(resetUserPassword.pending, (state) => {
      state.single.resetingPassword = true
    })
})
